<template>
  <div class="complaint-group-page">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>客诉处理</el-breadcrumb-item>
        <el-breadcrumb-item>客诉反馈飞书群配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-form :inline="true" size="small" class="filter-form" @submit.native.prevent="search">
        <el-form-item label="游戏">
          <el-select v-model="query.tag_id" filterable clearable placeholder="全部游戏" :disabled="loading || optionsLoading">
            <el-option v-for="game in games" :key="game.id" :label="game.tag_name" :value="game.id" />
          </el-select>
        </el-form-item>
        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" :loading="loading" :disabled="optionsLoading" @click="search">搜索</el-button>
          <el-button type="warning" icon="el-icon-refresh" :disabled="loading || optionsLoading" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="table-toolbar">
        <strong>飞书群配置</strong>
        <el-button v-if="permissions.create" type="success" size="small" icon="el-icon-plus" :disabled="loading || optionsLoading || saving || detailLoading || statusChangingId !== null" @click="openCreate">新增</el-button>
      </div>
      <el-table v-loading="loading" :data="rows" border size="small" empty-text="暂无群配置" class="group-table">
        <el-table-column label="游戏" min-width="160">
          <template slot-scope="scope">
            <div v-for="game in scope.row.games" :key="game.tag_id">{{ game.tag_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="group_name" label="飞书群名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="mention_bot_name" label="消息 @ 机器人" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.mention_bot_name || '待配置' }}</template>
        </el-table-column>
        <el-table-column label="Chat ID" min-width="230">
          <template slot-scope="scope">
            <span class="chat-id">{{ scope.row.chat_id }}</span>
            <el-button type="text" size="mini" @click="copyChatId(scope.row.chat_id, $event)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="75">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="飞书值班表" width="115">
          <template slot-scope="scope">
            <a v-if="isDutySheetUrl(scope.row.duty_sheet_url)" :href="scope.row.duty_sheet_url" target="_blank" rel="noopener noreferrer">查看值班表</a>
            <span v-else>链接无效</span>
          </template>
        </el-table-column>
        <el-table-column prop="fallback_operator_name" label="全局兜底运营" min-width="120" />
        <el-table-column prop="updated_by_name" label="更新人" min-width="95" />
        <el-table-column prop="updated_at" label="更新时间" width="165" />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="permissions.update" type="primary" size="mini" :disabled="loading || detailLoading || saving || statusChangingId !== null" @click="openEdit(scope.row)">编辑</el-button>
            <el-button v-if="permissions.status" :type="scope.row.status === 1 ? 'danger' : 'success'" size="mini"
              :loading="statusChangingId === scope.row.id" :disabled="loading || saving || detailLoading || statusChangingId !== null" @click="toggleStatus(scope.row)">
              {{ scope.row.status === 1 ? '停用' : '启用' }}
            </el-button>
            <span v-if="!permissions.update && !permissions.status">—</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background :current-page="query.page" :page-size="query.limit" :total="total"
          layout="total, prev, pager, next" :disabled="loading" @current-change="changePage" />
      </div>
    </div>

    <el-dialog :title="form.id ? '编辑飞书群配置' : '新增飞书群配置'" :visible.sync="dialogVisible" width="800px"
      :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving" :before-close="closeDialog" @closed="resetDialogState">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="140px" :disabled="saving" size="small">
        <el-form-item label="游戏" prop="tag_ids">
          <div v-if="form.id" class="readonly-games">
            <el-tag v-for="game in editGames" :key="game.tag_id" size="small">{{ game.tag_name }}</el-tag>
            <div class="form-help">关联游戏创建后不可修改</div>
          </div>
          <el-select v-else v-model="form.tag_ids" multiple filterable placeholder="请选择关联游戏">
            <el-option v-for="game in games" :key="game.id" :label="game.tag_name" :value="game.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="Chat ID" prop="chat_id"><el-input v-model.trim="form.chat_id" maxlength="128" placeholder="请输入 oc_ 开头的 Chat ID" @input="chatIdChanged" /></el-form-item>
        <el-form-item label="飞书群名称" prop="group_name">
          <el-input :value="form.group_name" readonly placeholder="填写 Chat ID 后自动获取群名">
            <el-button slot="append" :loading="groupInfoLoading" :disabled="!validChatId() || groupInfoLoading || saving" @click="loadGroupInfo">重新获取</el-button>
          </el-input>
          <div v-if="groupInfoError" class="form-error">{{ groupInfoError }}</div>
          <div class="form-help">群名自动获取，获取失败时无法保存。权限不足时请在<router-link to="/setting-personal">个人中心</router-link>重新完成飞书授权。</div>
        </el-form-item>
        <el-form-item label="消息 @ 机器人" prop="mention_bot_open_id">
          <el-input v-model="botQuery" clearable maxlength="50" placeholder="请输入机器人名称关键词" class="bot-query"
            :disabled="!validChatId()" @input="botQueryChanged" @keyup.enter.native.prevent="loadBots()">
            <el-button slot="append" icon="el-icon-search" :disabled="!validChatId() || !botQuery.trim() || botsLoading || saving" @click="loadBots()">搜索</el-button>
          </el-input>
          <el-select v-model="form.mention_bot_open_id" :loading="botsLoading" :disabled="!validChatId() || !botQuery.trim() || loadedChatId !== form.chat_id || loadedBotQuery !== botQuery.trim() || botsLoading"
            placeholder="请输入机器人名称关键词并搜索后选择" no-data-text="未找到匹配的机器人" @change="selectedBotChanged">
            <el-option v-if="form.mention_bot_open_id && !form.bot_selection_token" :value="form.mention_bot_open_id" label="原配置机器人（请重新搜索确认）" disabled />
            <el-option v-for="bot in bots" :key="bot.open_id" :value="bot.open_id" :label="bot.name + '（' + bot.open_id + '）'" />
          </el-select>
          <el-button type="text" :disabled="!validChatId() || !botQuery.trim() || botsLoading || saving" @click="loadBots()">重新搜索机器人</el-button>
          <el-button v-if="botsHasMore" type="text" :loading="botsLoading" :disabled="saving" @click="loadBots(true)">加载更多</el-button>
          <div v-if="botsError" class="form-error">{{ botsError }}</div>
          <div v-if="botsNotice" class="form-help">{{ botsNotice }}</div>
          <div class="form-help">输入名称关键词搜索当前群内机器人，再手动选择要 @ 的机器人。需先在<router-link to="/setting-personal">个人中心</router-link>完成飞书授权；保存时将使用你的飞书账号邀请本应用机器人入群。</div>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status" :disabled="!!form.id && !permissions.status">
            <el-radio :label="1">启用</el-radio><el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="飞书值班表链接" prop="duty_sheet_url"><el-input v-model.trim="form.duty_sheet_url" maxlength="1000" placeholder="请输入飞书电子表格或知识库值班表链接" /></el-form-item>
        <el-form-item label="全局兜底运营" prop="fallback_operator_admin_id">
          <el-select v-model="form.fallback_operator_admin_id" filterable placeholder="请选择">
            <el-option v-if="missingOperator" :label="missingOperator.name + '（已不可用，请重新选择）'" :value="missingOperator.id" disabled />
            <el-option v-for="operator in operators" :key="operator.id" :label="operator.name" :value="operator.id" />
          </el-select>
          <div class="form-help">每条配置选择一人，值班表当日无人时使用</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="saving" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" :disabled="botsLoading || groupInfoLoading || groupInfoChatId !== form.chat_id || !form.group_name || !form.bot_selection_token" @click="submit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { getComplaintGroupOptions, getComplaintGroupInfo, getComplaintGroupBots, getComplaintGroups, getComplaintGroup, saveComplaintGroup, setComplaintGroupStatus } from '@/api/complaintFeishuGroup';

const emptyForm = () => ({ id: null, tag_ids: [], group_name: '', chat_id: '', mention_bot_open_id: '', bot_selection_token: '', status: 1, duty_sheet_url: '', fallback_operator_admin_id: null });
function isDutySheetUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password && !url.port
      && /^(?:[a-z0-9-]+\.)*(?:feishu\.cn|larksuite\.com)$/.test(url.hostname)
      && /^\/(sheets|wiki)\/[a-zA-Z0-9]+\/?$/.test(url.pathname);
  } catch (error) { return false; }
}

export default {
  name: 'complaintFeishuGroupConfig',
  data() {
    return {
      loading: false, optionsLoading: false, detailLoading: false, saving: false, statusChangingId: null,
      dialogVisible: false, rows: [], total: 0, games: [], operators: [], editGames: [], missingOperator: null,
      groupInfoLoading: false, groupInfoError: '', groupInfoChatId: '', groupInfoRequestId: 0, groupInfoTimer: null,
      bots: [], botsLoading: false, botsHasMore: false, botsPageToken: '', botsError: '', botsNotice: '', botQuery: '', loadedBotQuery: '', loadedChatId: '', botsRequestId: 0, botsTimer: null,
      permissions: { create: false, update: false, status: false },
      query: { tag_id: null, page: 1, limit: 20 }, form: emptyForm(),
      rules: {
        tag_ids: [{ type: 'array', required: true, min: 1, message: '至少选择一个关联游戏', trigger: 'change' }],
        group_name: [{ required: true, whitespace: true, max: 50, message: '请先成功获取飞书群名称，最多50个字符', trigger: 'change' }],
        chat_id: [{ required: true, pattern: /^oc_[a-zA-Z0-9]+$/, max: 128, message: 'Chat ID 须以 oc_ 开头，后面为字母或数字', trigger: 'blur' }],
        mention_bot_open_id: [{ required: true, message: '请手动选择后续消息要 @ 的机器人', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        duty_sheet_url: [{ required: true, validator: (rule, value, callback) => callback(isDutySheetUrl(value) ? undefined : new Error('请填写 https 的飞书电子表格或知识库值班表链接')), trigger: 'blur' }],
        fallback_operator_admin_id: [{ required: true, message: '请选择全局兜底运营', trigger: 'change' }],
      },
    };
  },
  created() { this.initialize(); },
  beforeDestroy() { this.resetDialogState(); },
  methods: {
    isDutySheetUrl,
    validChatId() { return /^oc_[a-zA-Z0-9]+$/.test(this.form.chat_id) && this.form.chat_id.length <= 128; },
    resetGroupInfo() {
      clearTimeout(this.groupInfoTimer); this.groupInfoTimer = null; this.groupInfoRequestId += 1;
      this.groupInfoLoading = false; this.groupInfoError = ''; this.groupInfoChatId = ''; this.form.group_name = '';
    },
    resetDialogState() { this.resetBotState(); this.resetGroupInfo(); },
    async loadGroupInfo() {
      clearTimeout(this.groupInfoTimer); this.groupInfoTimer = null;
      if (!this.dialogVisible || this.saving || !this.validChatId()) return;
      const chatId = this.form.chat_id;
      const requestId = ++this.groupInfoRequestId;
      this.groupInfoLoading = true; this.groupInfoError = ''; this.groupInfoChatId = ''; this.form.group_name = '';
      try {
        const data = await getComplaintGroupInfo({ chat_id: chatId });
        if (requestId !== this.groupInfoRequestId || this.form.chat_id !== chatId || !this.dialogVisible) return;
        if (data.chat_id !== chatId || typeof data.group_name !== 'string' || !data.group_name.trim() || Array.from(data.group_name).length > 50) {
          throw new Error('飞书群名称响应异常，请重新获取');
        }
        this.form.group_name = data.group_name; this.groupInfoChatId = chatId;
        this.$nextTick(() => this.$refs.groupForm.clearValidate('group_name'));
      } catch (error) {
        if (requestId !== this.groupInfoRequestId || this.form.chat_id !== chatId || !this.dialogVisible) return;
        this.groupInfoError = error instanceof Error && !error.response && !error.config ? error.message : '群名获取失败，请重试';
      } finally {
        if (requestId === this.groupInfoRequestId) this.groupInfoLoading = false;
      }
    },
    resetBotState() {
      clearTimeout(this.botsTimer); this.botsTimer = null; this.botsRequestId += 1;
      this.bots = []; this.botsLoading = false; this.botsHasMore = false; this.botsPageToken = '';
      this.loadedChatId = ''; this.loadedBotQuery = ''; this.botsError = ''; this.botsNotice = '';
      this.form.mention_bot_open_id = ''; this.form.bot_selection_token = '';
    },
    chatIdChanged() {
      this.resetBotState(); this.botQuery = '';
      this.resetGroupInfo();
      if (this.validChatId()) this.groupInfoTimer = setTimeout(() => this.loadGroupInfo(), 500);
    },
    botQueryChanged() {
      this.resetBotState();
      if (this.validChatId() && this.botQuery.trim()) {
        this.botsTimer = setTimeout(() => this.loadBots(), 500);
      }
    },
    selectedBotChanged() {
      const selected = this.bots.find(bot => bot.open_id === this.form.mention_bot_open_id);
      this.form.bot_selection_token = selected ? selected.selection_token : '';
    },
    async loadBots(more = false) {
      clearTimeout(this.botsTimer); this.botsTimer = null;
      const chatId = this.form.chat_id;
      const query = this.botQuery.trim();
      if (!this.dialogVisible || this.botsLoading || !this.validChatId() || !query) return;
      if (Array.from(query).length > 50) { this.botsError = '机器人名称关键词最多50个字符'; return; }
      if (more && (!this.botsHasMore || this.loadedChatId !== chatId || this.loadedBotQuery !== query)) return;
      const pageToken = more ? this.botsPageToken : '';
      const requestId = ++this.botsRequestId;
      if (!more) { this.bots = []; this.loadedChatId = ''; this.loadedBotQuery = ''; this.form.bot_selection_token = ''; this.botsHasMore = false; this.botsPageToken = ''; }
      this.botsLoading = true; this.botsError = ''; this.botsNotice = '';
      try {
        const data = await getComplaintGroupBots({ chat_id: chatId, query, ...(pageToken ? { page_token: pageToken } : {}) });
        if (requestId !== this.botsRequestId || this.form.chat_id !== chatId || this.botQuery.trim() !== query || !this.dialogVisible) return;
        const candidates = more ? this.bots.concat(data.items || []) : (data.items || []);
        const unique = new Map(candidates.map(bot => [bot.open_id, bot]));
        this.bots = Array.from(unique.values()); this.loadedChatId = chatId; this.loadedBotQuery = query;
        this.botsHasMore = !!data.has_more; this.botsPageToken = data.page_token || ''; this.botsNotice = data.notice || '';
        this.selectedBotChanged();
        if (!this.form.bot_selection_token && !this.botsHasMore) this.form.mention_bot_open_id = '';
        if (!this.bots.length && !this.botsHasMore) this.botsError = '未找到匹配的机器人，请更换名称关键词，或确认 Chat ID、群内机器人及你的可见范围';
      } catch (error) {
        if (requestId !== this.botsRequestId || this.form.chat_id !== chatId || this.botQuery.trim() !== query || !this.dialogVisible) return;
        this.botsError = error instanceof Error && !error.response && !error.config ? error.message : '机器人加载失败，请重试';
      } finally {
        if (requestId === this.botsRequestId) this.botsLoading = false;
      }
    },
    showError(error) {
      // 公共请求拦截器已展示权限/网络错误；只补充本模块业务错误。
      if (error instanceof Error && !error.response && !error.config) this.$message.error(error.message);
    },
    async initialize() { await this.loadOptions(); await this.loadList(); },
    async loadOptions() {
      this.optionsLoading = true;
      try {
        const data = await getComplaintGroupOptions();
        this.games = (data.games || []).map(game => ({ ...game, id: Number(game.id) }));
        this.operators = (data.operators || []).map(operator => ({ ...operator, id: Number(operator.id) }));
        this.permissions = data.permissions || { create: false, update: false, status: false };
      } catch (error) { this.showError(error); }
      finally { this.optionsLoading = false; }
    },
    async loadList() {
      if (this.loading) return;
      this.loading = true;
      try {
        const data = await getComplaintGroups({ ...this.query });
        this.rows = data.data || [];
        this.total = Number(data.total || 0);
      } catch (error) { this.showError(error); }
      finally { this.loading = false; }
    },
    search() { if (this.loading) return; this.query.page = 1; this.loadList(); },
    resetQuery() { if (this.loading) return; this.query = { tag_id: null, page: 1, limit: 20 }; this.loadList(); },
    changePage(page) { if (this.loading) return; this.query.page = page; this.loadList(); },
    openCreate() {
      if (!this.permissions.create || this.saving) return;
      this.resetDialogState();
      this.botQuery = '';
      this.form = emptyForm(); this.editGames = []; this.missingOperator = null; this.openDialog();
    },
    async openEdit(row) {
      if (!this.permissions.update || this.detailLoading) return;
      this.detailLoading = true;
      try {
        const data = await getComplaintGroup(row.id);
        this.resetDialogState();
        this.editGames = data.games || [];
        const operatorId = Number(data.fallback_operator_admin_id);
        this.missingOperator = this.operators.some(operator => operator.id === operatorId) ? null : { id: operatorId, name: data.fallback_operator_name };
        this.form = {
          id: data.id, tag_ids: this.editGames.map(game => Number(game.tag_id)), group_name: '',
          chat_id: data.chat_id, status: Number(data.status), duty_sheet_url: data.duty_sheet_url, fallback_operator_admin_id: operatorId,
          mention_bot_open_id: data.mention_bot_open_id || '', bot_selection_token: '',
        };
        this.botQuery = Array.from(data.mention_bot_name || '').slice(0, 50).join('');
        this.openDialog();
        await Promise.all([this.loadGroupInfo(), this.loadBots()]);
      } catch (error) { this.showError(error); }
      finally { this.detailLoading = false; }
    },
    openDialog() { this.dialogVisible = true; this.$nextTick(() => this.$refs.groupForm.clearValidate()); },
    closeDialog(done) { if (!this.saving) done(); },
    submit() {
      if (this.saving || this.botsLoading || this.groupInfoLoading) return;
      this.$refs.groupForm.validate(async valid => {
        if (!valid || this.saving) return;
        if (this.groupInfoChatId !== this.form.chat_id || !this.form.group_name || this.groupInfoError) {
          this.$message.error('请先成功获取当前 Chat ID 对应的飞书群名称'); return;
        }
        if (this.loadedChatId !== this.form.chat_id || this.loadedBotQuery !== this.botQuery.trim() || !this.form.bot_selection_token) {
          this.$message.error('请按名称关键词搜索当前群机器人并手动选择'); return;
        }
        if (!this.operators.some(operator => operator.id === this.form.fallback_operator_admin_id)) {
          this.$message.error('请选择正常状态的工单用户作为全局兜底运营'); return;
        }
        this.saving = true;
        try {
          await saveComplaintGroup(this.form);
          this.$message.success('飞书群配置已保存'); this.dialogVisible = false;
          await this.loadList();
        } catch (error) { this.showError(error); }
        finally { this.saving = false; }
      });
    },
    async toggleStatus(row) {
      if (!this.permissions.status || this.statusChangingId !== null) return;
      const status = row.status === 1 ? 0 : 1;
      const action = status === 1 ? '启用' : '停用';
      this.statusChangingId = row.id;
      try {
        await this.$confirm(`确认${action}“${row.group_name}”吗？`, `${action}确认`, { type: 'warning', confirmButtonText: '确认', cancelButtonText: '取消' });
        await setComplaintGroupStatus(row.id, status);
        this.$message.success(`配置已${action}`);
        await this.loadList();
      } catch (error) { this.showError(error); }
      finally { this.statusChangingId = null; }
    },
    copyChatId(value, event) {
      const clipboard = new Clipboard(event.currentTarget, { text: () => value });
      clipboard.on('success', () => { this.$message.success('Chat ID 已复制'); clipboard.destroy(); });
      clipboard.on('error', () => { this.$message.error('复制失败，请选中 Chat ID 手动复制'); clipboard.destroy(); });
      clipboard.onClick(event);
    },
  },
};
</script>

<style scoped>
.complaint-group-page { padding: 0 4px; }
.filter-form { border-bottom: 1px solid #ebeef5; margin-bottom: 16px; }
.filter-actions { float: right; }
.table-toolbar { display: flex; align-items: center; justify-content: space-between; min-height: 40px; margin-bottom: 12px; }
.table-toolbar strong { font-size: 15px; color: #303133; }
.chat-id { word-break: break-all; user-select: text; margin-right: 8px; }
.group-table a { color: #409eff; }
.pagination { margin-top: 16px; text-align: right; }
.el-select { width: 100%; }
.filter-form .el-select { width: 260px; }
.bot-query { margin-bottom: 8px; }
.readonly-games .el-tag { margin-right: 6px; margin-bottom: 6px; }
.form-help { font-size: 12px; color: #909399; line-height: 20px; margin-top: 4px; }
.form-error { font-size: 12px; color: #f56c6c; line-height: 20px; }
.form-help a { color: #409eff; }
@media (max-width: 900px) { .filter-actions { float: none; } }
</style>
